module.exports = __webpack_public_path__ + "img/soproni.6621f7b1.png";